import moment from 'moment/moment';

export const validateFeedbackFormDates = (values) => {
  const errors = {};
  const today = moment().startOf('day');

  if (!values.startDate) {
    errors.startDate = 'Start date is required.';
  }

  if (!values.endDate) {
    errors.endDate = 'End date is required.';
  }

  if (values.endDate) {
    const startDate = moment(values.endDate);
    if (startDate.isBefore(today)) {
      errors.endDate = 'End date cannot be in the past.';
    }
  }

  if (values.startDate && values.endDate) {
    const startDate = moment(values.startDate);
    const endDate = moment(values.endDate);

    if (startDate.isAfter(endDate)) {
      errors.startDate = 'Start date must be less than end date.';
      errors.endDate = 'End date must be more than start date.';
    }
  }

  return errors;
};
